/** @jsx jsx */
import { jsx } from 'theme-ui';
import Layout from '@fify.at/gatsby-theme-base/src/components/Layout/Layout';

export default function HomePageLayout(props) {
  return <Layout {...props} sx={{ paddingTop: 0 }} />;
}
